import { RentWagonSellPauseCause } from 'rentWagonSell/api';

export const rentWagonSellPauseCauseLabel = (cause: RentWagonSellPauseCause) =>
  ({
    ROUTINE_REPAIR: 'Текущий ремонт',
    SCHEDULED_REPAIR: 'Деповский ремонт',
    PAUSED: 'Пауза',
  }[cause]);
